/**
 * SectionHeader Component
 *
 * Section header with step badge, label, and optional right element.
 */

import { StepBadge } from './StepBadge';
import type { ISectionHeaderProps } from '@/@types/avatars';

export const SectionHeader = ({ step, label, rightElement }: ISectionHeaderProps) => {
  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-2">
        <StepBadge step={step} />
        <span className="text-sm font-medium text-foreground">{label}</span>
      </div>
      {rightElement && <div>{rightElement}</div>}
    </div>
  );
};
